export default __webpack_public_path__ + "static/media/client43.0572ba0d.png";